import { createStyles, makeStyles } from "@material-ui/core/styles";
import { FilledTextFieldProps } from "@material-ui/core/TextField";
import CancelIcon from "@material-ui/icons/CancelRounded";
import ValidIcon from "@material-ui/icons/CheckCircleRounded";
import ErrorIcon from "@material-ui/icons/ErrorRounded";
import LockIcon from "@material-ui/icons/LockRounded";
import clsx from "clsx";
import React from "react";
import { Color } from "../theme";
import { PlainFunctionComponent } from "../types";
import { IconButton } from "../interaction";

export interface EndAdornmentContentProps {
    className?: string;
    disabled: FilledTextFieldProps["disabled"];
    disableClearButton?: boolean;
    disableLockIcon?: boolean;
    disableValidationIcon?: boolean;
    error: FilledTextFieldProps["error"];
    focus: boolean;
    onClear: (event: React.ChangeEvent<unknown>) => void;
    value: unknown;
}

export const EndAdornmentContent: PlainFunctionComponent<EndAdornmentContentProps> = ({
    className,
    disabled,
    disableClearButton,
    disableLockIcon,
    disableValidationIcon,
    error,
    focus,
    onClear,
    value,
}) => {
    const dontGrabFocusOnMouseDown = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const classes = useStyles();
    if (disabled) {
        return disableLockIcon ? <></> : <LockIcon className={clsx(className, classes.icon, classes.disabled)} />;
    }
    if (focus && value) {
        return disableClearButton ? (
            <></>
        ) : (
            <IconButton aria-label="clear" className={classes.clearButton} onClick={onClear} onMouseDown={dontGrabFocusOnMouseDown}>
                <CancelIcon />
            </IconButton>
        );
    }
    if (!disableValidationIcon) {
        return error ? (
            <ErrorIcon className={clsx(className, classes.icon, classes.error)} />
        ) : value ? (
            <ValidIcon className={clsx(className, classes.icon, classes.valid)} />
        ) : (
            <></>
        );
    }

    return <></>;
};

const useStyles = makeStyles(
    createStyles({
        clearButton: {
            margin: 6,
        },
        icon: {
            margin: 12,
        },
        error: {
            color: Color.red1,
        },
        disabled: {
            color: Color.grey4,
        },
        valid: {
            color: Color.blue1,
        },
    }),
);
